
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor03On as ObiBipolar_transistor03OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-03-on.js';
 
 
 

 
 export const ObiBipolar_transistor03On = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-03-on',
   elementClass: ObiBipolar_transistor03OnElement,
   events: {
     
   }
  });
 
 